export const FontSizes = [
	{ label: 'h1', value: 'var(--font-size-heading-1)' },
	{ label: 'h2', value: 'var(--font-size-heading-2)' },
	{ label: 'h3', value: 'var(--font-size-heading-3)' },
	{ label: 'h4', value: 'var(--font-size-heading-4)' },
	{ label: 'h5', value: 'var(--font-size-heading-5)' },
	{ label: 'h6', value: 'var(--font-size-heading-6)' },

	{ label: 'xs', value: 'var(--font-size-body-xs)' },
	{ label: 'sm', value: 'var(--font-size-body-sm)' },
	{ label: 'md', value: 'var(--font-size-body-md)' },
	{ label: 'lg', value: 'var(--font-size-body-lg)' },
] as const;

export type FontSizeType = (typeof FontSizes)[number];
